import "./utils/fetch_monitor.js";
import { showToastMessage } from './utils/toast_message.js';
import { initCharacterBrowser } from "./utils/characters/character_browser.js";

window.showToastMessage = showToastMessage;

document.addEventListener('DOMContentLoaded', function() {
    initializePage();
})

function initializePage(){
    window.configAlertTimeout = document.getElementById('window-alert-timeout').dataset.alertTimeout;

    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => new bootstrap.Popover(el));

    // Character list is server-rendered, so only the toolbar needs wiring
    initCharacterBrowser(document.querySelector('[data-character-browser]'));
}
